const stages = [
  {
    step: 'Этап 1',
    icon: 'ri-search-line',
    title: 'Диагностика бизнеса',
    desc: 'Анализ текущего состояния компании: KPI, бизнес-процессы, финансовые показатели. Определяем точки роста, где обучение даст максимальный эффект. Изучаем стратегию компании и планы развития на 1-3 года.'
  },
  {
    step: 'Этап 2',
    icon: 'ri-chat-3-line',
    title: 'Интервью',
    desc: 'Проводим глубинные интервью с руководителями и ключевыми сотрудниками. Выявляем реальные потребности, разрывы в компетенциях и ожидания от обучения. Собираем кейсы из практики компании.'
  },
  {
    step: 'Этап 3',
    icon: 'ri-focus-3-line',
    title: 'Определение компетенций',
    desc: 'Формируем модель компетенций для каждой целевой группы. Определяем приоритетные навыки для развития. Согласовываем с руководителями, какие изменения в работе сотрудников будут считаться результатом.'
  },
  {
    step: 'Этап 4',
    icon: 'ri-grid-line',
    title: 'Матрица обучения',
    desc: 'Создаём матрицу: какие группы сотрудников, каким компетенциям, в каком формате обучаются. Определяем последовательность модулей и длительность каждого этапа программы.'
  },
  {
    step: 'Этап 5',
    icon: 'ri-pencil-ruler-2-line',
    title: 'Проектирование программы',
    desc: 'Разрабатываем структуру программы, учебные материалы, кейсы и упражнения на основе реальных ситуаций компании. 80% контента — практика на материале заказчика. Согласовываем программу с руководством.'
  },
  {
    step: 'Этап 6',
    icon: 'ri-presentation-line',
    title: 'Проведение обучения',
    desc: 'Запускаем программу по модулям. Каждый модуль: минимум теории (20%), максимум практики (80%). Используем бизнес-игры, ролевые упражнения, групповую работу. Собираем обратную связь после каждого модуля.'
  },
  {
    step: 'Этап 7',
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Между модулями участники выполняют практические задания в реальной работе. Применяют изученные инструменты. Руководители поддерживают внедрение. Это критический этап — без практики обучение не работает.'
  },
  {
    step: 'Этап 8',
    icon: 'ri-bar-chart-box-line',
    title: 'Оценка результатов',
    desc: 'Проводим замеры: сравниваем KPI до и после обучения. Оцениваем изменение поведения сотрудников (модель Киркпатрика, уровень 3). Готовим отчёт для руководителей с конкретными цифрами.'
  },
  {
    step: 'Этап 9',
    icon: 'ri-user-heart-line',
    title: 'Сопровождение',
    desc: '2-3 месяца после завершения программы: чек-поинты, ответы на вопросы, корректировка. Закрепляем навыки, помогаем преодолеть сопротивление изменениям. При необходимости запускаем новый цикл развития.'
  }
];

export default function HowProgramIsDeveloped() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как разрабатывается программа обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-6 max-w-3xl mx-auto leading-relaxed">
          Девять этапов — от первой встречи до измеримого результата
        </p>
        <p className="text-sm md:text-base text-gray-500 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Разработка программы обычно занимает 2–4 недели, реализация и сопровождение — от 2 до 3 месяцев в зависимости от масштаба.
        </p>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-teal-200 hidden md:block"></div>

          <div className="space-y-0">
            {stages.map((s, i) => (
              <div key={i} className="relative flex items-start gap-6 pb-10 last:pb-0">
                <div className="relative z-10 w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md hidden md:flex">
                  <i className={`${s.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1 bg-white rounded-2xl p-6 border border-gray-100 shadow-sm">
                  <div className="md:hidden w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center mb-3">
                    <i className={`${s.icon} text-lg text-white`}></i>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-bold text-teal-600 bg-teal-50 px-2 py-1 rounded-md">{s.step}</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{s.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{s.desc}</p>
                  {i < stages.length - 1 && (
                    <div className="flex justify-center mt-4 md:hidden">
                      <i className="ri-arrow-down-line text-teal-400 text-xl"></i>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}